// skipcq: JS-W1028
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

/**
 * Back navigation link for brewhouse portal pages.
 *
 * @param {object} props
 * @param {string} props.to
 * @param {string} props.label
 */
function BrewhouseBackLink({ to, label, compact = false, sx = {} }) {
  return (
    <Button
      component={RouterLink}
      to={to}
      startIcon={<ArrowBackIcon fontSize={compact ? 'small' : 'medium'} />}
      size={compact ? 'small' : 'medium'}
      sx={{
        mb: compact ? 0 : 2,
        textTransform: 'none',
        alignSelf: 'flex-start',
        minWidth: 0,
        px: compact ? 1 : undefined,
        ...sx,
      }}
    >
      {label}
    </Button>
  );
}

BrewhouseBackLink.propTypes = {
  to: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  compact: PropTypes.bool,
  sx: PropTypes.object,
};

export default BrewhouseBackLink;
